import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import setupApiAuth from './utils/apiAuth';
import { ConfigProvider } from 'antd';
import trTR from 'antd/locale/tr_TR'; 
import 'antd/dist/reset.css';

// Kendi API'mize giden tüm isteklere (axios VE fetch) oturum token'ını ekler.
// Bir kısım uç eskiden auth istemiyordu; uçlar korunurken 100'ü aşkın çağrı
// yerini tek tek düzeltmek yerine başlık merkezî olarak ekleniyor.
setupApiAuth();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ConfigProvider locale={trTR}>
      <App />
    </ConfigProvider>
);
